import productivityBoostSvg from "../../assets/OntologyCardsIcons/productivity_boost.svg";
import costOptimizationSvg from "../../assets/OntologyCardsIcons/cost_opt.svg";
import roiMaximizationSvg from "../../assets/OntologyCardsIcons/roi_max.svg";

export interface CardData {
  id: number;
  title: string;
  description: string;
  iconSrc: string;
}

export const cardsData: CardData[] = [
  {
    id: 1,
    title: "PRODUCTIVITY BOOST",
    description:
      "Cledar's cuts decision cycles from weeks to hours, increasing productivity four times",
    iconSrc: productivityBoostSvg,
  },
  {
    id: 2,
    title: "COST OPTIMIZATION",
    description:
      "Ontology-driven platform reduces decision cycle delivering up to 10% OPEX savings",
    iconSrc: costOptimizationSvg,
  },
  {
    id: 3,
    title: "ROI MAXIMIZATION",
    description:
      "Cledar provides the semantic glue that allows faster deployment, higher ROI",
    iconSrc: roiMaximizationSvg,
  },
];

export const sectionTitle = "Ontology-driven AI";

export const sectionDescription =
  "Cledar turns fragmented data into a single source of truth, laying the foundation for enterprise AI adoption";
